/* src/app/modules/subscription/promotion-included-dialog/promotion-included-dialog.component.css */
.promotion-dialog {
  padding: 22px 24px 18px;
  text-align: center;
}
.promotion-title {
  margin: 0 0 12px;
  font-size: 1.3rem;
  font-weight: 700;
  color: #0f172a;
}
.promotion-line {
  margin: 0;
  color: #334155;
  font-size: 0.95rem;
}
.promotion-price {
  margin: 8px 0 0;
  color: #0f172a;
  font-size: 1.05rem;
  font-weight: 700;
}
.promotion-note {
  margin: 12px 0 0;
  color: #64748b;
  font-size: 0.9rem;
}
.promotion-actions {
  margin-top: 18px;
  display: flex;
  justify-content: center;
}
.btn-ok {
  border: none;
  background: var(--cf-brand-dark);
  color: #ffffff;
  border-radius: 8px;
  padding: 9px 18px;
  font-weight: 700;
  cursor: pointer;
}
/*# sourceMappingURL=promotion-included-dialog.component.css.map */
